import React from 'react';
import { Dialog, DialogContent, DialogTitle, DialogDescription } from './ui/dialog';
import { Button } from './ui/button';
import { X, Check, Lock } from 'lucide-react';

const MISSING = [
  'Unlimited daily puzzles',
  'Detailed progress insights',
  'Priority support',
];

// Confirms the downgrade choice and makes the Free Plan limits explicit
const FreePlanDialog = ({ open, onExplore, onContinueFree, onClose }) => (
  <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
    <DialogContent className="max-w-md bg-[#2A1810] border border-[#4a3221] text-[#F5EDE0] rounded-3xl p-6 sm:p-7 max-h-[90vh] overflow-y-auto" data-testid="free-plan-dialog">
      <DialogTitle className="font-serif text-2xl leading-tight">Are you sure?</DialogTitle>
      <DialogDescription className="text-[#B8A990] text-sm mt-1">
        The Free Plan gives you <mark className="bg-[#F4C430] text-[#2A1810] font-bold rounded px-1.5 py-0.5" data-testid="free-plan-highlight">only 5 puzzles</mark> a day — one each from Logic, Memory, Attention, Speed and Math.
      </DialogDescription>
      <ul className="mt-5 space-y-2.5" data-testid="free-plan-missing">
        {MISSING.map((m) => (
          <li key={m} className="flex items-center gap-2.5 text-sm text-[#D9C9B3]">
            <span className="h-6 w-6 rounded-full grid place-items-center bg-red-500/10 border border-red-400/40 shrink-0"><X size={13} className="text-red-300" /></span>
            {m}
          </li>
        ))}
        <li className="flex items-center gap-2.5 text-sm text-[#D9C9B3]">
          <span className="h-6 w-6 rounded-full grid place-items-center bg-red-500/10 border border-red-400/40 shrink-0"><Lock size={12} className="text-red-300" /></span>
          Mixed Skills stays locked
        </li>
      </ul>
      <div className="mt-5 rounded-2xl bg-[#3D2817] border border-[#F4C430]/40 p-3.5 text-xs text-[#D9C9B3] flex items-start gap-2">
        <Check size={14} className="text-[#F4C430] mt-0.5 shrink-0" />
        Every paid plan starts with a 7-day free trial — no charge for 7 days, cancel anytime.
      </div>
      <Button onClick={onExplore} data-testid="free-plan-explore"
        className="mt-5 w-full rounded-full bg-[#F4C430] hover:bg-[#FFD34E] text-[#2A1810] font-semibold h-12">
        Explore other plans
      </Button>
      <button onClick={onContinueFree} data-testid="free-plan-continue"
        className="mt-2 w-full min-h-[44px] text-sm text-[#B8A990] hover:text-[#F5EDE0]">
        No thanks! I will continue with the free plan
      </button>
    </DialogContent>
  </Dialog>
);

export default FreePlanDialog;
